import { render } from "./ArticleListItemSkeleton.vue?vue&type=template&id=4e75ff2c&scoped=true"
import script from "./ArticleListItemSkeleton.vue?vue&type=script&lang=js"
export * from "./ArticleListItemSkeleton.vue?vue&type=script&lang=js"

import "./ArticleListItemSkeleton.vue?vue&type=style&index=0&id=4e75ff2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e75ff2c"

export default script